import clsx from "clsx";
import { ReactElement, useState } from "react";

type Props = {
    title: string;
    content: ReactElement;
}

export const HelpCenterAccordion = ({ title, content }: Props) => {
    const [open, setOpen] = useState<boolean>(true);


    return (
        <div className="help-center-accordion">
            <div className={clsx("help-center-accordion-header", {'help-center-accordion-open': open})} onClick={() => setOpen(prev => !prev)}>
                {title}
                <button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                        <path d="M0.530273 5.0625L4.53027 1.0625L8.53027 5.0625" stroke="#262626" stroke-width="1.5"/>
                    </svg>
                </button>
            </div>

            { open && content }
        </div>
    )
}